<template>

    <div class="watchlist-item">

        <div class="row align-items-center g-3">

            <div class="col-6 col-lg-1">
                <inertia-link :href="item.product.permalink" v-if="item.product_available">
                    <img class="img-fluid thumbnail" :src="item.product.main_image_url" alt="" loading="lazy" />
                </inertia-link>
            </div>
            <div class="col-6 col-lg-3">
                <h5 class="">
                    <inertia-link :href="item.product.permalink" class="link-dark" v-if="item.product_available">
                        {{ item.product.name }}
                    </inertia-link>
                    <div v-else>
                        {{ item.product_name }}
                    </div>
                </h5>
                <div class="small" v-if="item.product">
                    {{ __('Lieferanten-Artikelnr.: :number', {number: item.product.supplier_pid}) }}
                </div>

                <template v-if="item.product_available">
                    <tax-info :product="item.product" />
                    <delivery-info :product="item.product" />
                </template>

            </div>
            <div class="col-6 col-lg-1">
                <div>
                    {{ item.price | localizeAmount }}
                </div>
                <div class="small text-secondary text-nowrap" v-if="item.product && item.product.price_quantity > 1">
                    {{ __('je :quantity Stck.', {quantity: item.product.price_quantity}) }}
                </div>
            </div>
            <div class="col-6 col-lg-2">
                <div>
                    {{ item.created_at | localizeDateTime }}
                </div>
            </div>
            <div class="col-6 col-lg-3">
                <form @submit.prevent="addToCartForm.post(route('cart.add-item', {product: item.product, from_watchlist: true}), {preserveScroll: true, preserveState: false})">
                    <div class="d-flex gap-2" v-if="item.product_available">
                        <quantity 
                            v-model.number="addToCartForm.quantity"
                            :min="item.product.quantity_min"
                            :max="item.product.quantity_max"
                            :interval="item.product.quantity_interval"
                            />
                        <button
                            class="btn btn-lg btn-outline-primary px-4 text-nowrap"
                            type="submit"
                            :disabled="addToCartForm.processing"
                            :title="__('In den Warenkorb legen')"
                            >
                            <i class="bi bi-cart"></i>
                            <span class="d-none d-xl-inline">
                                {{ __('Cart') }}
                            </span>
                        </button>
                    </div>
                    <div class="text-danger" v-else>
                        {{ __('Das Produkt ist aktuell nicht verfügbar.') }}
                    </div>
                </form>
            </div>
            <div class="col-12 col-lg-2 text-lg-end">
                <inertia-link 
                    :href="route('watchlist.remove-item', item.product_id)"
                    as="button"
                    type="button"
                    method="delete"
                    class="btn btn-lg btn-outline-danger"
                    >
                    <i class="bi bi-x-lg"></i>
                    <span class="d-none d-xl-inline">
                        {{ __('Entfernen') }}
                    </span>
                </inertia-link>
            </div>
        </div>

        <hr />

    </div>

</template>

<script>

    import TaxInfo from '@/shared/TaxInfo';
    import DeliveryInfo from '@/shared/DeliveryInfo';
    import Quantity from '@/shared/Quantity';

    export default {
        props: [
            'item',
        ],
        data() {
            return {
                addToCartForm: this.$inertia.form({
                    quantity: this.item.quantity,
                }),
            }
        },
        components: {
            TaxInfo,
            DeliveryInfo,
            Quantity,
        },
        watch: {
        },
        computed: {
        },
        methods: {
        },
    }
</script>
